import { IDialogButton } from "./Dialogs";
import { IDialogAction, types } from "./Dialogs.actions";

export interface IDialogsStateProps {
  el: HTMLElement;
  title: "";
  message: "";
  showing: false;
  cover: false;
  centerMessage: false;
  scrollable: true;
  buttons: IDialogButton[];
}

const defaultState: IDialogsStateProps = {
  el: null,
  title: "",
  message: "",
  showing: false,
  cover: false,
  centerMessage: false,
  scrollable: true,
  buttons: []
};

export const dialogs = (state = defaultState, action: IDialogAction) => {
  switch (action.type) {
    case types.SHOW_DIALOG:
      return {
        ...state,
        showing: true,
        title: action.title,
        message: action.message,
        buttons: action.buttons,
        cover: action.cover,
        centerMessage: action.centerMessage
      };
    case types.HIDE_DIALOG:
      return { ...state, showing: false };
    default:
      return state;
  }
};
